import { StylesConfig } from 'react-select'
import styled from 'styled-components'

import { dropdownStyles } from '../../../common/features/ocpp-settings/OcppSettings.style'

export const SInput = styled.input<{ error?: boolean }>`
    display: block;
    width: 50%;
    height: 34px;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.5em;
    color: #555555;
    border: 1px solid ${({ error }) => (error ? '#a94442' : '#cccccc')};
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);

    &.error {
        border-color: ${({ theme }) => theme.font.errorColor};
    }

    &:disabled {
        background-color: #eeeeee;
    }
`

export const SExternalServerLink = styled.p`
    padding-top: 7px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`

export const SCheckbox = styled.label`
    display: flex;
    align-items: center;
    gap: 3px;

    input[type='checkbox'] {
        margin: 0;
    }

    span {
        padding-top: 4px;
    }
`

type DropdownOption = {
    label: string
    value: string
}

export const chargePointDetailsDropdownStyles: StylesConfig<DropdownOption, false> = {
    ...(dropdownStyles as StylesConfig<DropdownOption, false>),
    singleValue: (styles) => ({
        ...styles,
        fontSize: 14,
        color: '#555555',
        padding: '0 10px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: '100%',
        textOverflow: 'ellipsis',
    }),
    placeholder: (styles) => ({
        ...styles,
        fontSize: 14,
        color: '#555555',
        padding: '0 10px',
    }),
}

export const SFormRow = styled.div`
    padding-bottom: 15px;
`
